import {LoginState} from '../Types/LoginState';

const loginStorageKey = 'loginStorageKey';
interface LoginStateStore {
  loginState: LoginState;
  userGroups: string;
}

export const setLoginStateGlobally = (state: LoginState, usergroups: string): void => {
  sessionStorage.setItem(loginStorageKey, state);
  sessionStorage.setItem(loginStorageKey + 'UserGroups', usergroups);
};

export function getStoredLoginState(): LoginStateStore {
  const loginState: LoginState | null = <LoginState | null>sessionStorage.getItem(loginStorageKey);
  const userGroups: string = sessionStorage.getItem(loginStorageKey + 'UserGroups') || '';
  if (!loginState) {
    setLoginStateGlobally('loggedOut', '');
    return {
      loginState: 'loggedOut',
      userGroups,
    };
  }
  return {
    loginState,
    userGroups,
  };
}
